// string의 마지막 글자가 받침을 가지는지 확인
export const hasJong = (value: string): boolean =>
  (value.charCodeAt(value.length - 1) - 0xac00) % 28 > 0;
